/**
 *
 * This is the start page for the scheduler which
 * will display anything that the user has scheduled,
 * some details about the event/session to be
 * scheduled, and a link to schedule.
 *
 */
import * as React from 'react';
import {observer} from "mobx-react";
import {IResDay} from "shared/ResDay";
import {IReservation} from "shared/IReservation";

import './SchedulerOverview.pcss';
import {action, computed, observable} from "mobx";
import {NoSlotsAvailable} from "components/reservations/NoSlotsAvailable";
import {DateTimeFormat, DateTimeHelpers} from "shared/DateTimeHelpers";
import {DateTime, Duration} from "luxon";

interface Props {
  bundleName:string;
  sessionLength:number;
  reservations:IReservation[]|null;
  resDays:IResDay[];
  onClickScheduleASession:()=>void;
  onClickResDay:(resDay:IResDay)=>void;
  onClickReservation:(reservation:IReservation)=>void;
  onCancelReservation:(reservation:IReservation)=>void;
  onClickSlot:(slot:DateTime)=>Promise<any>;
  onReschedule?:(reservation:IReservation)=>void;

  isMultiDay:boolean;
  isMultiTime:boolean;
  noSlotsAvailable:boolean;

  uiWordSlot:string;          // slot, seat, ticket,
  uiWordEventType:string;
  uiWordReservation: string;
  uiPhraseSlotDescription: string;
  uiWordReserve: string;

  timezone: string;
}



@observer
export class SchedulerOverview extends React.Component<Props> {

  @observable reservingSlot = false;
  /**
   * Only called when the reservation setup is for a single
   * reservation at a single time.
   *
   */
  @action handleReserveSlot = () => {
    if(!this.reservingSlot && this.reservations.length===0) {
      this.reservingSlot = true;
      const slot =DateTimeHelpers.parseDateTime( this.props.resDays[0].resDayResources[0].resTimes[0].time );
      if(null!==slot) {
        this.props.onClickSlot(slot).then(this.afterSlotCompletion).catch(this.afterSlotCompletion);
      } else {
        this.afterSlotCompletion();
      }
    }
  }

  @action handleReschedule = (reservation:IReservation) => {
      if(this.props.onReschedule) {
        this.props.onReschedule(reservation);
      }
  }

  @action afterSlotCompletion = () => {
      this.reservingSlot = false;
  }

  @computed get reservations() {
    return this.props.reservations ? this.props.reservations : [];
  }

  render() {
    const {onClickReservation} = this.props;

    return (
      <div className={"scheduler-overview"}>

        {/*{!this.props.isMultiTime ?*/}
        {/*  <>*/}
        {/*    {this.reservations.length===0 ?*/}
        {/*      (this.props.noSlotsAvailable ?*/}
        {/*        <NoSlotsAvailable uiWordSlot={this.props.uiWordSlot} />*/}
        {/*        :*/}
        {/*        <div className="white-button-stack">*/}
        {/*          <button className="white full" onClick={this.handleReserveSlot}>{this.props.uiWordReserve} your {this.props.uiWordSlot}</button>*/}
        {/*        </div>*/}
        {/*        )*/}
        {/*      :*/}
        {/*      <ScheduledSlot*/}
        {/*        bundleName={this.props.bundleName}*/}
        {/*        onCancelReservation={this.props.onCancelReservation}*/}
        {/*        reservation={this.reservations[0]}*/}
        {/*        uiWordSlot={this.props.uiWordSlot}*/}
        {/*        uiWordReservation={this.props.uiWordReservation}*/}
        {/*      />*/}
        {/*    }*/}
        {/*  </>*/}
        {/*:<></>}*/}


            {this.reservations.length > 0 &&
              <div className="so-reservations">

                  {this.reservations.map(reservation => {
                    const startTime = DateTimeHelpers.parseDateTime(reservation.time);
                    if (null === startTime) {
                      return null;
                    }
                    const endTime = startTime.plus(Duration.fromObject({minutes: reservation.length}));

                    return (
                      <div className="so-res-item" key={reservation._id} >
                        <div className={"so-res-item-head"}>
                          <div aria-hidden><span className={'material-icons'}>event_available</span></div>
                          <h3 style={{marginBottom: '10px'}}>{this.props.uiWordEventType} on&nbsp;
                            {DateTimeHelpers.format(startTime, DateTimeFormat.DATE_START_TIME, this.props.timezone)}-{DateTimeHelpers.format(endTime, DateTimeFormat.TIME_SIMPLE_PLUS_ZONE, this.props.timezone)}
                          </h3>
                        </div>
                        <div className="white-button-stack">
                          {this.props.isMultiTime && this.props.onReschedule && <button className="white" onClick={()=>{ this.handleReschedule(reservation) }}><span>Reschedule</span><span className={"material-icons"} aria-hidden={true}>arrow_forward_ios</span></button>}
                          <button className="white" onClick={() => {
                            this.props.onCancelReservation(reservation);
                          }}>Cancel {this.props.uiWordReservation}</button>
                        </div>
                      </div>
                    );
                  })}
              </div>
            }


        { (!this.props.isMultiTime && this.reservations.length === 0 || this.props.isMultiTime ) &&
          <>
            <h3 style={{marginBottom: '10px'}}>New Reservation</h3>
            {this.props.noSlotsAvailable ?
              <NoSlotsAvailable uiWordSlot={this.props.uiWordSlot}/>
              :
              <div className="white-button-stack">
                <button className="white full" onClick={this.props.onClickScheduleASession}>
                  <span>{this.props.uiWordReserve} now</span>
                  <span className={"material-icons"} aria-hidden={true}>arrow_forward_ios</span>
                </button>
              </div>
            }
          </>
        }

      </div>
    );
  }

}

